export const OfficeFinancePlusState = {
	url: '/finance-option-finance-plus/:type_id/:id',
	title: 'Office Finance+',
	template: '<finance-option-finance-plus></finance-option-finance-plus>',
	params: {id: null, type_id: null, type_name: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeFinanceOptionFinancePlusPageMod" */
			'@Containers/office-finance-options/finance-option-finance-plus.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
